/* 🤖 this file was generated by svg-to-ts */
export const myIconLockInvertedCircle: {
  name: 'lock_inverted_circle';
  data: string;
} = {
  name: 'lock_inverted_circle',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30"><g fill="none" fill-rule="evenodd"><circle cx="15" cy="15" r="15" fill="#B1B2B4" transform="rotate(180 15 15)"/><path fill="#222" d="M20.782 23.037H9.134c-.804 0-1.456-.65-1.456-1.45v-7.258c0-.801.652-1.452 1.456-1.452h.728V10.7c0-2.805 2.282-5.08 5.096-5.08 2.815 0 5.097 2.275 5.097 5.08v2.177h.727c.805 0 1.456.65 1.456 1.452v7.257c0 .8-.652 1.451-1.456 1.451ZM17.87 10.7a2.908 2.908 0 0 0-2.912-2.902 2.908 2.908 0 0 0-2.912 2.902v2.177h5.824V10.7Z"/></g></svg>`,
};
